import axios from "axios";
import Jsona from "jsona";

let url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function get() {
  const options = {
    /*   headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    }, */
  };

  if (!url) {
    url = "https://misepis-api.delfromsoftware.com/api";
  }
  return axios
    .get(`${url}/users/me?populate=*`, options)
    .then((response) => {
      //console.log(response);
      //console.log(jsona.deserialize(response));
      return {
        /*  list: jsona.deserialize(response), */
        list: response.data,
        meta: response.meta,
      };
    })
    .catch(function (error) {
      if (error.response) {
        // La respuesta fue hecha y el servidor respondió con un código de estado
        // que esta fuera del rango de 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        // La petición fue hecha pero no se recibió respuesta
        // `error.request` es una instancia de XMLHttpRequest en el navegador y una instancia de
        // http.ClientRequest en node.js
        console.log(error.request);
      } else {
        // Algo paso al preparar la petición que lanzo un Error
        console.log("Error", error.message);
      }
    });
}

function update(profile) {
  const payload = jsona.serialize({
    stuff: profile,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(`${url}/me?include=roles`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

export default {
  get,
  update,
};
